// @flow
export const ALL_MEMBERS = 'All';
export const LAST_INVITATION_REINVITE_MINUTES = 5;
export const PATIENT_CREATED_REINVITE_MINUTES = 5;
export const REINVITE_TOOLTIP =
  'This member has either recently been created \nor has already received an invite within the \nlast 5 minutes. Please check back in a few minutes.';
export const MEMBER_LIST_DESCRIPTION =
  'View members by Program. Access their profiles for additional detail and actions.';
